import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
  path: "/login",
  component: () =>
    import("@/views/login/index"),
  hidden: true,
},
{
  path: "/404",
  component: () =>
    import("@/views/404"),
  hidden: true,
},
{
  path: "/",
  component: Layout,
  redirect: "/myQualification/myQualification-index",
},
{
  path: "/myQualification",
  component: Layout,
  redirect: "/myQualification",
  hidden: true,
  meta: { title: "我的资质", icon: "dashboard" },
  children: [{
    path: "myQualification-index",
    name: "index",
    component: () =>
      import("@/views/myQualification/index"),
    meta: { title: "我的资质", icon: "dashboard" },
  },],
},
{
  path: "/user",
  component: Layout,
  redirect: "/user",
  hidden: true,
  children: [{
    path: "info",
    name: "info",
    component: () =>
      import("@/views/user/index"),
    meta: { title: "个人中心", icon: "dashboard" },
  },],
},
{
  path: "/invoiceHome",
  name: "invoiceHome",
  component: Layout,
  hidden: true,
  children: [
    {
      path: "/invoiceIndex",
      name: "invoiceIndex",
      component: () => import("@/views/invoiceCenter/invoiceIndex"),
      meta: { title: "开票业务", icon: "dashboard" },
    },
    {
      path: "/invoiceApplication",
      name: "invoiceApplication",
      component: () => import("@/views/invoiceCenter/invoiceApplication"),
      meta: { title: "开票业务", icon: "dashboard" },
    },
    {
      path: "/invoiceAdd",
      name: "invoiceAdd",
      component: () => import("@/views/invoiceCenter/invoiceAdd"),
      meta: { title: "开票业务", icon: "dashboard" },
    },
  ]
},
{
  path: "/dashboard",
  component: Layout,
  redirect: "/myQualification/myQualification-index",
  hidden: true,
},
{
  path: "/404",
  component: () => import("@/views/404"),
  hidden: true,
},
// {
//   path: "/",
//   component: Layout,
//   redirect: "/ordercenter/ordercenter-procurement",
// },
{
  path: "/user",
  component: Layout,
  redirect: "/user",
  hidden: true,
  children: [
    {
      path: "info",
      name: "info",
      component: () => import("@/views/user/index"),
      meta: { title: "个人中心", icon: "dashboard" },
    },
  ],
},
{
  path: "/dashboard",
  component: Layout,
  redirect: "/ordercenter/ordercenter-procurement",
  hidden: true,
},
// {
//   path: "/mymerchantsettlementb",
//   name: "mymerchantSettlementb",
//   component: () => import("@/views/merchantsettlement/index"),
//   meta: { title: "我的资质管理", icon: "form" },
//   hidden: true,
// },
{
  path: "/myQualification",
  name: "myQualification",
  component: () => import("@/views/myQualification/index"),
  //import("@/views/qualificationDetails/qualificationDetails"),
  meta: { title: "我的资质", icon: "form" },
  hidden: true,
},
/**新的资质提交页面 */
{
  path: "/mymerchantsettlementb",
  name: "mymerchantsettlementb",
  component: () => import("@/views/myQualification/index"),
  meta: { title: "我的资质管理", icon: "form" },
  hidden: true,
},
{
  path: "/storeSettleIn",
  name: "storeSettleIn",
  component: () => import("@/views/storeSettleIn/index"),
  meta: { title: "店铺入驻", icon: "form" },
  hidden: true,
},
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  { path: "*", redirect: "/404", hidden: true },
];

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [

];

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
